<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
        'branch': Object,
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        appName() {
            return process.env.VUE_APP_NAME
        }
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();

            if (vm.branch.id)
                vm.data.branch_id = vm.branch.id;
        },
        newData() {
            var vm = this;

            var data = {
                branch_id: null,
                email: null
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;
            vm.$loading.on('branch_detail_employee_invite_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Employee.invite(postData);

                var data = resp.data;

                vm.$flash.success(data.message);

                vm.success(vm.data);
                vm.$sidebar.hide();
            } catch (err) {
                vm.$flash.error(err.response.data.message);
            }
            vm.$loading.off('branch_detail_employee_invite_submit');
        },
        _createPostData: function (data) {
            return data;
        },
    }
}
</script>

<template>
    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow>
                    <BCol>
                        <BAlert :model-value="true" variant="warning" class="alert-border-left shadow">
                            <i class="mdi mdi-information-outline align-middle fs-16"></i>
                            {{ $t('employee.info.invite', { app: appName }) }}
                        </BAlert>
                    </BCol>
                </BRow>
                <BRow class="gy-3">
                    <BCol lg="12">
                        <label for="email" class="form-label">{{ $t('employee.label.email') }}</label>
                        <input type="email" v-model="data.email" class="form-control" id="email"
                            :placeholder="$t('employee.placeholder.email')" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="$ac.hasAccess('employee_full_access') || ($ac.hasAccess('employee_create') && $ac.hasAccessStore(branch.store_id))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="success" class="w-100" @click="submit"
                                    :disabled="$loading.get('branch_detail_employee_invite_submit')">
                                    <loading :loading="$loading.get('branch_detail_employee_invite_submit')"
                                        variant="light" type="button">
                                        <i class="mdi mdi-share-variant-outline align-bottom me-1"></i>
                                        {{ $t('employee.btn.invite') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>